var React = require('react');

function CloseX (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"1.99925","height":"55.9791","transform":"matrix(0.707 0.707213 -0.707 0.707213 40.0791 0.493874)","fill":"white","key":0}),React.createElement("rect",{"width":"1.99925","height":"55.9791","transform":"matrix(0.707085 -0.707128 0.707085 0.707128 0.493164 1.90812)","fill":"white","key":1})]);
}

CloseX.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = CloseX;

CloseX.default = CloseX;
